import classNames from 'classnames/bind';
import { gql } from '@apollo/client';
import styles from './AcfStyledList.module.scss';
import { Image, RichText } from '@/components';
let cx = classNames.bind(styles);

export default function AcfStyledList(props) {
	const { styledList, attributes } = props;
  const listStyles = styledList.styles || [];
  const className = attributes.className?.split(' ') || [];

	return (
		<>
			{styledList.list.length > 0 && (
				<ul id={attributes.anchor} className={cx(['ns_styled-list', 'styled-list', ...className, ...listStyles])}>
					{styledList.list.map((listItem, index) => {
						if (listItem.text) {
							return (
								<li className={cx(['ns_styled-list-item', 'list-item'])} key={index}>
									{listStyles.includes('use-icons') && listItem.icon && (
										<div className={cx('icon-container')}>
											<Image image={listItem.icon} fill={true} objectFit='contain' objectPosition='center center' />
										</div>
                  )}
                    <RichText html={listItem.text} className={cx('text-container')} />
								</li>
							);
						}
					})}
				</ul>
			)}
		</>
	);
}

AcfStyledList.fragments = {
	key: `AcfStyledListFragment`,
	entry: gql`
		${Image.fragments.entry}
		fragment AcfStyledListFragment on AcfStyledlist {
			attributes {
        anchor
        className
      }
      styledList {
        list {
          text
          icon {
            ...ImageFragment
          }
        }
        styles
      }
		}
	`,
};

AcfStyledList.config = {
	name: 'AcfStyledlist',
};
AcfStyledList.displayName = 'AcfStyledlist';
